import { render } from "./JobDetailSpecific.vue?vue&type=template&id=5d223d52&scoped=true"
import script from "./JobDetailSpecific.vue?vue&type=script&lang=js"
export * from "./JobDetailSpecific.vue?vue&type=script&lang=js"

import "./JobDetailSpecific.vue?vue&type=style&index=0&id=5d223d52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d223d52"]])

export default __exports__